export default "__VITE_ASSET__BOztXJa4__"